import { render, staticRenderFns } from "./FiltrosMonitoria.vue?vue&type=template&id=2f59aff9&scoped=true&"
import script from "./FiltrosMonitoria.vue?vue&type=script&lang=js&"
export * from "./FiltrosMonitoria.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosMonitoria.vue?vue&type=style&index=0&id=2f59aff9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f59aff9",
  null
  
)

export default component.exports